import {
  SIMULADOR_FINANCIERO_GET_LINEA_FINANCIERA_BY_ID_BEGIN,
  SIMULADOR_FINANCIERO_GET_LINEA_FINANCIERA_BY_ID_SUCCESS,
  SIMULADOR_FINANCIERO_GET_LINEA_FINANCIERA_BY_ID_FAILURE,
  SIMULADOR_FINANCIERO_GET_LINEA_FINANCIERA_BY_ID_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_SF } from '../../../common/config';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getLineaFinancieraById({id = ''} = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SIMULADOR_FINANCIERO_GET_LINEA_FINANCIERA_BY_ID_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(REACT_APP_API_SF + "/credits/" + id);
      doRequest.then(
        (res) => {
          dispatch({
            type: SIMULADOR_FINANCIERO_GET_LINEA_FINANCIERA_BY_ID_SUCCESS,
            data: res.data.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SIMULADOR_FINANCIERO_GET_LINEA_FINANCIERA_BY_ID_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetLineaFinancieraByIdError() {
  return {
    type: SIMULADOR_FINANCIERO_GET_LINEA_FINANCIERA_BY_ID_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_GET_LINEA_FINANCIERA_BY_ID_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getLineaFinancieraByIdPending: true,
        getLineaFinancieraByIdError: null,
      };

    case SIMULADOR_FINANCIERO_GET_LINEA_FINANCIERA_BY_ID_SUCCESS:
      // The request is success
      let aux = {...state.editLineaData};
      let cuotas = [...action.data.cuotas];
      let lineas = [];
      const car_lot_id = [];

      action.data.lineas.forEach((linea) => {
        lineas.push(
          {
            id: linea.id,
            data: {
              idBrand: linea.brandId,
              nameBrand: linea.brand,
              idModel: linea.modelId,
              nameModel: linea.model,
              idVersion: linea.versionId,
              nameVersion: linea.version,
              year: linea.yearMMV,
              year_desde: linea.yearMMV_desde,
              car_lot_id: linea.car_lot_id
            },
            newLinea: false
          }
        )
        car_lot_id.push(linea.car_lot_id)
      })
      cuotas.forEach((cuota) => {
        cuota['showDelete'] = true;
        cuota['showEdit'] = true;
        cuota['newCuota'] = false;
      });
      aux = {
        id: action.data.lineaCredito.id,
        datosFinancieros: {
          entidadOtorgante: { label: action.data.lineaCredito.entidadOtorgante, value: action.data.lineaCredito.entidadOtorganteID, id: 'entidadOtorgante' },
          tipoCredito: { label: action.data.lineaCredito.TipoLineaCredito, value: action.data.lineaCredito.tipoCreditoID, id: 'tipoCredito' },
          lineaCreditoBancaria: action.data.lineaCredito.nombreLineaCredito,
          estadoLCDesc: action.data.lineaCredito.estadoLCDesc,
          lineaComercial: action.data.lineaCredito.nombreLineaComercial,
          tipoTasa: { label: action.data.lineaCredito.Tasa, value: action.data.lineaCredito.tipoTasaID, id: 'tipoTasa' },
          cuotas: [...cuotas],
          cuotasPreviousValues: [...cuotas],
          cuotasDeleted: [],
          requisitos: action.data.lineaCredito.requisitos,
          fechaVigenciaIni: mySqlStringToDate(action.data.lineaCredito.fechaVigenciaDesde),
          fechaVigenciaFin: mySqlStringToDate(action.data.lineaCredito.fechaVigenciaHasta),
          promocionClienteBanco: action.data.lineaCredito.promocionClienteBanco === 1 ? true : false,
          beneficio: action.data.lineaCredito.beneficio,
          bloqueado: action.data.lineaCredito.bloqueado,
          nuevo: !!action.data.lineaCredito.tipoVehiculo,
          venta_directa:  action.data.lineaCredito.venta_directa,
          venta_convencional:  action.data.lineaCredito.venta_convencional,
          car_lot_id: car_lot_id.flat(),
          exceedFinanceLimit: action.data.lineaCredito.exceedFinanceLimit,
        },
        asignacionLineas: {
          tipoVehiculo: action.data.lineaCredito.tipoVehiculo,
          antiguedad: {},
          marca: { label: 'Todas', value: null, id: 'marca' },
          modelo: { label: 'Todos', value: null, id: 'modelo' },
          version: { label: 'Todas', value: null, id: 'version' },
          lineas: [...lineas],
          lineasDeleted: []
        }
      }

      return {
        ...state,
        editLineaData: aux,
        getLineaFinancieraByIdPending: false,
        getLineaFinancieraByIdError: null,
      };

    case SIMULADOR_FINANCIERO_GET_LINEA_FINANCIERA_BY_ID_FAILURE:
      // The request is failed
      return {
        ...state,
        getLineaFinancieraByIdPending: false,
        getLineaFinancieraByIdError: action.data.error,
      };

    case SIMULADOR_FINANCIERO_GET_LINEA_FINANCIERA_BY_ID_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getLineaFinancieraByIdError: null,
      };

    default:
      return state;
  }
}

function mySqlStringToDate (stringDate) {
  let result = null;
  if (stringDate !== null) {
    let auxSplit = stringDate.substring(0, 10).split("-");
    result = new Date(auxSplit[0], Number(auxSplit[1]) - 1, auxSplit[2]);
  }
  return result;
}